/* eslint-disable no-mixed-operators */
import mixpanel from "mixpanel-browser";
const projectToken = process.env.REACT_APP_MIXPANEL_TOKEN;
const ENV_PREFIX = process.env.REACT_APP_ENV_PREFIX || "production";

const localStorageGetItem = (key) => {
  try {
    return localStorage.getItem(`${ENV_PREFIX}_${key}`);
  } catch (e) {
    return null;
  }
};

const localStorageSetItem = (key, value) => {
  try {
    localStorage.setItem(`${ENV_PREFIX}_${key}`, value);
  } catch (e) {}
};

const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

let uniqueID = localStorageGetItem("unique_id");
if (!uniqueID) {
  uniqueID = generateUUID();
  localStorageSetItem("unique_id", uniqueID);
}

mixpanel.init(projectToken, {
  debug: true,
  api_host: "https://api-eu.mixpanel.com",
  persistence: "localStorage",
  ignore_dnt: true,
  loaded: (mp) => {
    // Check if user is already logged in
    try {
      const rawUserData = localStorageGetItem("userData");
      const token = localStorageGetItem("userToken");
      if (rawUserData && token) {
        const userData = JSON.parse(rawUserData);
        if (userData?.id) {
          mp.identify(userData.id);
          mp.people.set({
            $name:
              `${userData.firstName || ""} ${userData.lastName || ""}`.trim(),
            $email: userData.email || "",
            $phone: userData.phoneNumber || "",
          });
          return;
        }
      }
    } catch (e) {
      console.warn("Could not check local storage for identify fallback:", e);
    }
    // Fallback: anonymous user
    mp.identify(uniqueID);
  },
});

// Function to normalize the referrer
// eslint-disable-next-line no-unused-vars
const normalizeReferrer = (referrer) => {
  if (referrer.includes("instagram")) {
    return "Instagram";
  } else if (referrer.includes("facebook")) {
    return "Facebook";
  } else {
    return referrer;
  }
};

// Function to track events with Mixpanel
export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};
